import styled from 'styled-components';

export const SectionDefault = styled.section`
  p {
    padding-left: 8px;
    margin: 0px;
  }
`;
